import { render, staticRenderFns } from "./AssignTravelManagerModal.vue?vue&type=template&id=b9b5d934&scoped=true&"
import script from "./AssignTravelManagerModal.vue?vue&type=script&lang=js&"
export * from "./AssignTravelManagerModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignTravelManagerModal.vue?vue&type=style&index=0&id=b9b5d934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b5d934",
  null
  
)

export default component.exports